export default __webpack_public_path__ + "static/media/choppingblock.3734863b.png";